import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import MomentUtils from '@date-io/moment'
import { MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers'

function CustomTimePicker (props) {
    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <div className='timepicker'>
                <TimePicker
                    value={props.value ? moment(props.value, 'HH:mm') : moment('00:00', 'HH:mm')}
                    ampm={false}
                    autoOk
                    minutesStep={5}
                    onChange={time => props.handleChange(time)}
                    error={!!props.errorMessage}
                />
                {props.errorMessage && (
                    <span className='error d-inline-block font-xsmall color-red mt-2'>{props.errorMessage}</span>
                )}
            </div>
        </MuiPickersUtilsProvider>
    )
}

CustomTimePicker.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    handleChange: PropTypes.func,
    errorMessage: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
}

export default CustomTimePicker



// WEBPACK FOOTER //
// ./resources/js/components/CustomTimePicker.js